var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.625 0.125H3.11523C1.39648 0.125 0 1.54102 0 3.2793V40.7207C0 42.459 1.39648 43.875 3.11523 43.875H40.625C42.3438 43.875 43.75 42.459 43.75 40.7207V3.2793C43.75 1.54102 42.3438 0.125 40.625 0.125ZM13.2227 37.625H6.73828V16.7461H13.2324V37.625H13.2227ZM9.98047 13.8945C7.90039 13.8945 6.2207 12.2051 6.2207 10.1348C6.2207 8.06445 7.90039 6.375 9.98047 6.375C12.0508 6.375 13.7402 8.06445 13.7402 10.1348C13.7402 12.2148 12.0605 13.8945 9.98047 13.8945ZM37.5293 37.625H31.0449V27.4688C31.0449 25.0469 30.9961 21.9316 27.6758 21.9316C24.2969 21.9316 23.7793 24.5684 23.7793 27.293V37.625H17.2949V16.7461H23.5156V19.5977H23.6035C24.4727 17.957 26.5918 16.2285 29.7461 16.2285C36.3086 16.2285 37.5293 20.5547 37.5293 26.1797V37.625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.dd863e13bc5dba1adc1c52cf91227d97.svg";
export { ForwardRef as ReactComponent };